module.exports = __webpack_public_path__ + "img/meble.b48aba25.jpg";